// extracted by mini-css-extract-plugin
module.exports = {"hierarchy":"ratesAction_hierarchy__RtKJ6","price":"ratesAction_price__2cIS6"};